var map = {
	"./image.webp": 30,
	"./imagecopy.jpg": 791,
	"./logo.png": 806,
	"./logo.svg": 914,
	"./main-background.png": 991,
	"./me.jpg": 449,
	"./yagmur.jpeg": 513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;